import { useEffect, useRef } from "react";
import Card from "./Card";
import Button from "./Button";
import Text from "./Text";
import Flex from "./Flex";
import ConfirmStyle from "./css/Confirm.module.css";
import IcoInfo from "../../assets/img/ico_info.png";
import IcoWarning from "../../assets/img/ico_warning.png";

type ConfirmProps = {
    type?: "info" | "success" | "error" | "warning";
    title?: string;
    text?: string;
    confirmText?: string;
    cancelText?: string;
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

function matchTypeToIcon(type: ConfirmProps["type"]) {
    const style = {
        width: 24,
        height: 24
    }
    switch (type) {
        case "info":
            return <img src={IcoInfo} alt="info" style={style} />;
        default:
            return <img src={IcoWarning} alt="info" style={style} />;
    }
}

function Confirm({ 
    type = "info", 
    title = "확인", 
    text = "알림 내용", 
    confirmText = "확인", 
    cancelText = "취소",
    isOpen, 
    onConfirm, 
    onCancel 
}: ConfirmProps) {
    const backdropRef = useRef<HTMLDivElement>(null);
    const ConfirmIcon = matchTypeToIcon(type);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div 
            className={ConfirmStyle.backdrop} 
            ref={backdropRef}
        >
            <Card 
                className={ConfirmStyle.confirmContainer}
                shadow={24}
                borderRadius={16}
                padding={24}
                width={400}
                style={{ userSelect: 'none' }}
            >
                <Flex flexDirection="column" gap={24}>
                    <Flex flexDirection="column" gap={20}>
                        <Flex alignItems="center" gap={4}>
                            {ConfirmIcon}
                            <Text variant="h3" weight="lg" size="lg">
                                {title}
                            </Text>
                        </Flex>
                        {text && (
                            <Flex justifyContent="start">
                                <Text variant="p" size="md" color="#666" noWrap={false} style={{ lineHeight: "1.5rem", whiteSpace: "pre-wrap" }}>
                                    {text}
                                </Text>
                            </Flex>
                        )}
                    </Flex>
                    <Flex flexDirection="row" fullWidth justifyContent="end" gap={10}>
                        <Button type="button" onClick={onConfirm} variant="primary" >
                            {confirmText}
                        </Button>
                        <Button type="button" onClick={onCancel} variant="cancel" >
                            {cancelText}
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </div>
    );
}

export default Confirm;
export type { ConfirmProps };

